import React,{useState} from 'react'
import {Modal,Button} from 'react-bootstrap'
import {Row,Col} from 'react-bootstrap'
import {FaTimes} from 'react-icons/fa'
import {FaWindowClose} from 'react-icons/fa'
import {FaEdit} from 'react-icons/fa'
import {IconContext} from 'react-icons'
import {IoArrowBack} from 'react-icons/io5'

//import modal views
import ModalAboutView from './About/index.js'
import ModalSocialView from './Social/index.js'
import ModalEducationView from './Education/index.js'
import ModalSkillsView from './Skills/index.js'
import ModalProjectsView from './Projects/index.js'
import ModalCertificatesView from './Certificates/index.js'
import ModalLanguagesView from './Languages/index.js'
import ModalInterestsView from './Interests/index.js'
import ModalCocurricularView from './Cocurricular/index.js'
import ModalExperienceView from './Experience/index.js'
import ModalEditStructure from './EditStructure/index.js'


function EditModule(props) {

    const [showModal, setshowModal] = useState(false);
    const handleClose = () => setshowModal(false);
    const handleShow = () => setshowModal(true);
    const [ModalContent, setModalContent] = useState('DEFAULT')
    const goBackEditData = () => {
        setModalContent('EDITDATA');
    }
    const goBackDefault = () => {
        setModalContent('DEFAULT');
    }

    return (
        <>
            
            <Button className="btn py-2 px-2" onClick={()=>{handleShow();}}>
                <FaEdit/>&nbsp;Edit Resume
            </Button>


            <Modal className="custom-modal-dimensions" show={showModal} onHide={handleClose} size="xl">
                <Modal.Body className="px-4 pb-0">
                    <div className="px-4 cursor-pointer" style={{position:'absolute',top:'32px',right:'25px'}} onClick={handleClose}>
                        <IconContext.Provider value={{color:'#6c757d'}}>
                            <FaWindowClose/>
                        </IconContext.Provider>
                    </div>
                    {ModalContent === 'DEFAULT' && <>
                        <h5 className="py-3">Edit Resume</h5>
                        <Row className="d-flex justify-content-center" style={{minHeight:'300px'}}>
                            <Col md="6" className="py-md-5 mt-3 mt-md-0">
                                <div className="mb-4 bg-secondary mx-md-5 d-flex h-100 border rounded cursor-pointer" onClick={()=>setModalContent('EDITSTRUCTURE')}>
                                    <div className="d-inline-block mx-auto my-auto py-2 px-3">
                                        <FaEdit />
                                        <span> Edit Resume Structure</span>
                                    </div>
                                </div>
                            </Col>
                            <Col md="6" className="py-md-5 mt-3 mt-md-0">
                                <div className="mb-4 bg-secondary mx-md-5 d-flex h-100 border rounded cursor-pointer" onClick={()=>setModalContent('EDITDATA')}>
                                    <div className="d-inline-block mx-auto my-auto py-2 px-3">
                                        <FaEdit />
                                        <span> Edit Resume Data</span>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </>}
                    {ModalContent === 'EDITDATA' && <>
                        <h5 className="py-3">Edit Resume Data</h5>
                        <div style={{minHeight:'300px',display:'flex',flexDirection:'column',justifyContent:'center'}}>
                            <Row className="d-flex justify-content-center">
                                <Col md="4" lg="3">
                                    <p className="cursor-pointer text-secondary" onClick={()=>setModalContent('ABOUT')}>
                                        <IconContext.Provider value={{color:'var(--prime)'}}>
                                            <FaEdit />
                                        </IconContext.Provider>
                                        &nbsp;Edit About Data
                                    </p>
                                    <p className="cursor-pointer text-secondary" onClick={()=>setModalContent('SOCIAL')}>
                                        <IconContext.Provider value={{color:'var(--prime)'}}>
                                            <FaEdit />
                                        </IconContext.Provider>
                                        &nbsp;Edit Social Data
                                    </p>
                                    <p className="cursor-pointer text-secondary" onClick={()=>setModalContent('EDUCATION')}>
                                        <IconContext.Provider value={{color:'var(--prime)'}}>
                                            <FaEdit />
                                        </IconContext.Provider>
                                        &nbsp;Edit Education Data
                                    </p>
                                    <p className="cursor-pointer text-secondary" onClick={()=>setModalContent('EXPERIENCE')}>
                                        <IconContext.Provider value={{color:'var(--prime)'}}>
                                            <FaEdit />
                                        </IconContext.Provider>
                                        &nbsp;Edit Experience Data
                                    </p>
                                    <p className="cursor-pointer text-secondary" onClick={()=>setModalContent('SKILLS')}>
                                        <IconContext.Provider value={{color:'var(--prime)'}}>
                                            <FaEdit />
                                        </IconContext.Provider>
                                        &nbsp;Edit Skills Data
                                    </p>
                                </Col>
                                <Col md="4" lg="3">
                                    <p className="cursor-pointer text-secondary" onClick={()=>setModalContent('PROJECTS')}>
                                        <IconContext.Provider value={{color:'var(--prime)'}}>
                                            <FaEdit />
                                        </IconContext.Provider>
                                        &nbsp;Edit Projects Data
                                    </p>
                                    <p className="cursor-pointer text-secondary" onClick={()=>setModalContent('CERTIFICATES')}>
                                        <IconContext.Provider value={{color:'var(--prime)'}}>
                                            <FaEdit />
                                        </IconContext.Provider>
                                        &nbsp;Edit Certificates Data
                                    </p>
                                    <p className="cursor-pointer text-secondary" onClick={()=>setModalContent('LANGUAGES')}>
                                        <IconContext.Provider value={{color:'var(--prime)'}}>
                                            <FaEdit />
                                        </IconContext.Provider>
                                        &nbsp;Edit Languages Data
                                    </p>
                                    <p className="cursor-pointer text-secondary" onClick={()=>setModalContent('INTERESTS')}>
                                        <IconContext.Provider value={{color:'var(--prime)'}}>
                                            <FaEdit />
                                        </IconContext.Provider>
                                        &nbsp;Edit Interests Data
                                    </p>
                                    <p className="cursor-pointer text-secondary" onClick={()=>setModalContent('COCURRICULAR')}>
                                        <IconContext.Provider value={{color:'var(--prime)'}}>
                                            <FaEdit />
                                        </IconContext.Provider>
                                        &nbsp;Edit Cocurricular Data
                                    </p>
                                </Col>
                            </Row>
                        </div>
                    </>}
                    { ModalContent === 'ABOUT' && <ModalAboutView refreshData={props.refreshData} goBack={goBackEditData} handlerID={props.dataset_id._id} about={props.dataset_id.about} /> }
                    { ModalContent === 'SOCIAL' && <ModalSocialView refreshData={props.refreshData} goBack={goBackEditData} handlerID={props.dataset_id._id} social={props.dataset_id.social} /> }
                    { ModalContent === 'EDUCATION' && <ModalEducationView refreshData={props.refreshData} goBack={goBackEditData} handlerID={props.dataset_id._id} education={props.dataset_id.education} /> }
                    { ModalContent === 'EXPERIENCE' && <ModalExperienceView refreshData={props.refreshData} goBack={goBackEditData} handlerID={props.dataset_id._id} experience={props.dataset_id.experience} /> }
                    { ModalContent === 'SKILLS' && <ModalSkillsView refreshData={props.refreshData} goBack={goBackEditData} handlerID={props.dataset_id._id} skills={props.dataset_id.skills} /> }
                    { ModalContent === 'PROJECTS' && <ModalProjectsView refreshData={props.refreshData} goBack={goBackEditData} handlerID={props.dataset_id._id} projects={props.dataset_id.projects} /> }
                    { ModalContent === 'CERTIFICATES' && <ModalCertificatesView refreshData={props.refreshData} goBack={goBackEditData} handlerID={props.dataset_id._id} certificates={props.dataset_id.certificates} /> }
                    { ModalContent === 'LANGUAGES' && <ModalLanguagesView refreshData={props.refreshData} goBack={goBackEditData} handlerID={props.dataset_id._id} languages={props.dataset_id.languages} /> }
                    { ModalContent === 'INTERESTS' && <ModalInterestsView refreshData={props.refreshData} goBack={goBackEditData} handlerID={props.dataset_id._id} interests={props.dataset_id.interests} /> }
                    { ModalContent === 'COCURRICULAR' && <ModalCocurricularView refreshData={props.refreshData} goBack={goBackEditData} handlerID={props.dataset_id._id} cocurricular={props.dataset_id.cocurricular} /> }
                    { ModalContent === 'EDITSTRUCTURE' && <ModalEditStructure templateIdentity={props.templateIdentity} customOrder={props.customOrder} refreshCustomOrderData={props.refreshCustomOrderData} goBack={goBackDefault} handlerID={props.dataset_id._id} cocurricular={props.dataset_id.cocurricular} /> }
                </Modal.Body>
                {ModalContent === 'DEFAULT' && 
                    <div className="d-flex p-3 justify-content-between">
                        <Button variant='white' className="border border-black" style={{marginLeft:"auto"}} onClick={handleClose}>
                            <div className="d-flex align-items-center">
                                <IconContext.Provider value={{color:'#6c757d'}}>
                                    <FaTimes/> &nbsp;
                                </IconContext.Provider>
                                <p className="text-secondary mb-0">Close</p>
                            </div>
                        </Button>
                    </div>
                }
                {ModalContent === 'EDITDATA' && 
                    <div className="d-flex p-3 justify-content-between">
                        <Button variant='white' className="border border-black" onClick={()=>setModalContent('DEFAULT')}>
                            <div className="d-flex align-items-center">
                                <IconContext.Provider value={{color:'#6c757d'}}>
                                    <IoArrowBack/> &nbsp;
                                </IconContext.Provider>
                                <p className="text-secondary mb-0">Go Back</p>
                            </div>
                        </Button>
                        <Button variant='white' className="border border-black" style={{marginLeft:"auto"}} onClick={handleClose}>
                            <div className="d-flex align-items-center">
                                <IconContext.Provider value={{color:'#6c757d'}}>
                                    <FaTimes/> &nbsp;
                                </IconContext.Provider>
                                <p className="text-secondary mb-0">Close</p>
                            </div>
                        </Button>
                    </div>
                }
            </Modal>  
        </>
    )
}

export default EditModule
